import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ContactEmailRecipient } from '@core/models/deploy-plan-config.model';

import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';

import { buildRecipientsTooltipHtml } from '../deploy-recipients.utils';

/**
 * The recipients cell: the first address plus a "+N" chip, with the whole list revealed on
 * hover. The list is read-only, so it reveals rather than opens — the operator is scanning
 * rows to check who a deploy reaches, not acting on any one address.
 */
@Component({
  selector: 'app-deploy-recipients-cell',
  imports: [TranslatePipe, TooltipComponent],
  templateUrl: './deploy-recipients-cell.component.html',
  styles: ``
})
export class DeployRecipientsCellComponent {
  readonly recipients = input.required<ContactEmailRecipient[]>();

  protected readonly hiddenCount = computed(() =>
    Math.max(0, this.recipients().length - 1)
  );

  protected readonly tooltipHtml = computed(() =>
    buildRecipientsTooltipHtml(this.recipients())
  );
}
